import React from 'react'
import styled from 'styled-components'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Subtitle from 'components/Luxkit/Typography/Subtitle'

import PaneBody from 'components/Common/Pane/PaneBody'
import InlineGroup from 'components/Common/InlineGroup'
import HelpPane from 'components/Common/HelpPane'
import FormatCurrency from 'components/Common/FormatCurrency'
import { connect } from 'react-redux'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'

const SubtitleWithLine = styled(Subtitle)`
  border-left: 1px solid ${props => props.theme.palette.neutral.default.five};
`

// TEXT TODO: confirm with design
const GreySubtitle = styled(Subtitle)`
  color: ${props => props.theme.palette.neutral.default.four};
`

interface Props {
  onClose: () => void;
  onAccept: (newPrice: number) => void;
  isOpen: boolean;
  oldPrice: number;
  newPrice: number;
}

function BedbankPriceChangeModal(props: Props) {
  const {
    isOpen,
    onClose,
    onAccept,
    oldPrice,
    newPrice,
  } = props

  return (
    <ModalBase isOpen={isOpen}>
      <ModalHeader title="Prices have changed" />
      <ModalBody>
        <ModalContent>
          <VerticalSpacer gap={16}>
            <BodyText variant="large" align="center" as="p">
              Please review the new total price:
            </BodyText>
            <PaneBody size="lg">
              <InlineGroup size="xl" horizontal="center">
                <GreySubtitle variant="subtitle1" align="center">
                  Old price <br />
                  <FormatCurrency value={oldPrice} />
                </GreySubtitle>
                <SubtitleWithLine variant="subtitle1" align="center">
                  New price <br />
                  <FormatCurrency value={newPrice} />
                </SubtitleWithLine>
              </InlineGroup>
            </PaneBody>
            <HelpPane />
          </VerticalSpacer>
        </ModalContent>
      </ModalBody>
      <ModalFooter
        primaryActionProps={{
          children: 'Accept new price & checkout',
          onClick: () => onAccept(newPrice),
        }}
        secondaryActionProps={{
          children: 'Select different date',
          onClick: onClose,
        }}
      />
    </ModalBase>
  )
}

function mapStateToProps(state: App.State) {
  return {
    oldPrice: state.ui.modal.priceChange?.oldPrice ?? 0,
    newPrice: state.ui.modal.priceChange?.newPrice ?? 0,
  }
}

export default connect(mapStateToProps)(BedbankPriceChangeModal)
